import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AnalyticsProvider } from "@/lib/AnalyticsProvider";
import { CookieBanner } from "@/components/CookieBanner";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { BookNowFab } from "@/components/BookNowFab";

import HomePage from "@/pages/HomePage";
import JourneyPage from "@/pages/JourneyPage";
import TrainingPage from "@/pages/TrainingPage";
import WorkshopsPage from "@/pages/WorkshopsPage";
import KidsPage from "@/pages/KidsPage";
import EventsIndexPage from "@/pages/EventsIndexPage";
import EventDetailPage from "@/pages/EventDetailPage";
import OnlinePage from "@/pages/OnlinePage";
import BookingsPage from "@/pages/BookingsPage";
import ContactPage from "@/pages/ContactPage";
import PricingPage from "@/pages/PricingPage";
import SchedulePage from "@/pages/SchedulePage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import BlogIndexPage from "@/pages/BlogIndexPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import AdminPage from "@/pages/AdminPage";
import BAPathwayPage from "@/pages/BAPathwayPage";
import SchoolsOrganisationsPage from "@/pages/SchoolsOrganisationsPage";
import KidsRegistrationPage from "@/pages/KidsRegistrationPage";
import ThankYouPage from "@/pages/ThankYouPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import MerchPage from "@/pages/MerchPage";
import AdultRegistrationPage from "@/pages/AdultRegistrationPage";
import YouthTheatrePage from "@/pages/YouthTheatrePage";
import PoliciesPage from "@/pages/PoliciesPage";
import KidsReferralPage from "@/pages/KidsReferralPage";
import PrivateCoachingPage from "@/pages/PrivateCoachingPage";
import CareerApplicationPage from "@/pages/CareerApplicationPage";

function App() {
  return (
    <div className="App min-h-screen bg-black text-white antialiased">
      <BrowserRouter>
        <AnalyticsProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/journey" element={<JourneyPage />} />
            <Route path="/training" element={<TrainingPage />} />
            <Route path="/workshops" element={<WorkshopsPage />} />
            <Route path="/kids" element={<KidsPage />} />
            <Route path="/events" element={<EventsIndexPage />} />
            <Route path="/events/:slug" element={<EventDetailPage />} />
            <Route path="/online" element={<OnlinePage />} />
            <Route path="/bookings" element={<BookingsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/book" element={<SchedulePage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/blog" element={<BlogIndexPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/ba-pathway" element={<BAPathwayPage />} />
            <Route path="/schools-organisations" element={<SchoolsOrganisationsPage />} />
            <Route path="/kids-registration" element={<KidsRegistrationPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/merch" element={<MerchPage />} />
            <Route path="/adult-registration" element={<AdultRegistrationPage />} />
            <Route path="/youth-theatre" element={<YouthTheatrePage />} />
            <Route path="/policies" element={<PoliciesPage />} />
            <Route path="/policies/:slug" element={<PoliciesPage />} />
            <Route path="/kids-referral" element={<KidsReferralPage />} />
            <Route path="/private-coaching" element={<PrivateCoachingPage />} />
            <Route path="/apply/:track" element={<CareerApplicationPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <WhatsAppButton />
          <BookNowFab />
          <CookieBanner />
        </AnalyticsProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(255,218,31,0.4)",
            color: "white",
          },
        }}
      />
    </div>
  );
}

export default App;
